<style src="./Cmed.scss" lang="scss" scoped></style>
<template>
  <section class="cmed">
    <content-header path="Cadastro / CMED"/>

    <form v-on:submit.prevent="searchCmed">
      <section class="form-box row">
        <textbox
          v-model="filter.searchText"
          label="Buscar produto"
          placeholder="Digite o nome do produto"
          :class="{'col-9': showInsertNew, 'col-12': !showInsertNew}"
          :autofocus="true"
          :debounce="250"
          @debounce="searchCmed"/>

        <button class="btn-primary col-3" @click="addNew" v-if="showInsertNew">
          <icon-add />
          <span class="hide-md">Atualizar CMED</span>
        </button>
      </section>
    </form>

    <section class="form-box">
      <page-navigator
        :total-pages="paginator.totalPage"
        :per-page="paginator.perPage"
        v-model="paginator.actualPage" />
      <cmed-map
        :list-data="filteredList"/>
    </section>

    <right-side-panel ref="rspNewCmed" title="Atualizar CMED" :shortcut="['alt', 'n']">
      <new-cmed @refresh-list="refreshList" />
    </right-side-panel>

  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
import { NewCmed, CmedMap } from './components'
import { Textbox, SourcePaginatorMixin, PageNavigator } from '@/components/primitives'
import { IconAdd, IconEmpty } from '@/components/primitives/icons'
import { SearchCmed } from '@/brain/record/cmed'

export default {
  name: 'Cmed',
  components: {
    PageNavigator,
    ContentHeader,
    RightSidePanel,
    NewCmed,
    CmedMap,
    Textbox,
    IconAdd,
    IconEmpty
  },
  extends: {
    ...SourcePaginatorMixin
  },
  data () {
    return {
      filter: {
        searchText: ''
      },
      filteredList: []
    }
  },
  watch: {
    paginator: {
      handler () {
        this.searchCmed()
      },
      deep: true
    }
  },
  computed: {
    showInsertNew () {
      return this.$route.meta.mainArea !== 'research'
    }
  },
  mounted () {
    this.searchCmed()
  },
  methods: {
    addNew () {
      this.$refs.rspNewCmed.showPanel()
    },
    refreshList () {
      this.loadAll()
    },
    searchCmed () {
      if (this.filter.searchText.length < 1) {
        this.filteredList = []
        this.paginator.totalRegister = 0
        this.paginator.totalPage = 0
        return false
      }
      const params = this.buildQuery({ filters: this.filter })

      SearchCmed({ params })
        .then((result) => {
          this.filteredList = result.list
          this.paginator.totalRegister = result.rows
          this.paginator.totalPage = Math.floor(result.rows / this.paginator.perPage)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/cmed/Cmed.vue